let isProd = process.env.NODE_ENV === "production";

export default {
    // BASE_URL: isProd ? "" : "https://tumor.lightinai.com:1043",
    // BASE_URL: isProd ? "" : "https://tumor.lightinai.com",
    BASE_URL: isProd ? "" : "https://npkps.micrinhealth.com",
    isXp: checkOsXp(),
    aliyunImgurl: 'https://tumorxd.oss-cn-shanghai.aliyuncs.com',

    // api_version: '009',
    api_version: '008', // 正式

    // api_version: '007',
    // api_version: '006', //正式版

    version: 'v1.0.3',
    version_line: 'v1',
    name: '上海皓桦科技股份有限公司'
}
function checkOsXp() {
    let agent = navigator.userAgent;

    if (agent.indexOf("Windows NT 5") !== -1) {
        return true;
    } else if (agent.indexOf("Windows NT 7") !== -1) {
        return false;
    } else if (agent.indexOf("Windows NT 10") !== -1) {
        return false;
    } else {
        return false;
    }
}